import { useQuery } from "@tanstack/react-query";
import { getUser } from "../../services/apiAuth";
import { useHandleQueryError } from "../../lib/useHandleQueryError";
import { UserResponse } from "src/types";

export function useGetUser() {
  const {
    data: user,
    isPending,
    error,
    isSuccess,
    isError,
    refetch,
  } = useQuery<UserResponse>({
    queryKey: ["user"],
    queryFn: () => getUser(),
    gcTime: Infinity,
  });

  useHandleQueryError(isError, error, refetch);

  return {
    isPending,
    isError,
    error: error as { status?: number } | null,
    isSuccess,
    refetch,
    user: user?.data,
  };
}
